import { render, staticRenderFns } from "./ModalRating.vue?vue&type=template&id=7a8ee269&scoped=true&"
import script from "./ModalRating.vue?vue&type=script&lang=js&"
export * from "./ModalRating.vue?vue&type=script&lang=js&"
import style0 from "./ModalRating.vue?vue&type=style&index=0&id=7a8ee269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8ee269",
  null
  
)

export default component.exports